/**
 * Direktlink auf die Karte „Teamkalender → Outlook" unter Einstellungen → Microsoft — vom Hinweis auf
 * der Startseite und aus dem Kalender. Die Karte springt beim Öffnen mit dieser Marke zu sich und
 * hebt sich kurz hervor; der Reiter kommt aus `?tab=` (useAdminSettingsPage).
 */
export const CALENDAR_SYNC_SETUP_ANCHOR = 'teamkalender-outlook';
export const CALENDAR_SYNC_SETUP_PATH = `/admin/settings?tab=microsoft_sso#${CALENDAR_SYNC_SETUP_ANCHOR}`;
